import React, { useEffect, useState } from "react";
import WithoutAuthLayout from "../routeProtector/withoutAuth";
import Header from "../components/Home/Landing Page Components/Header";
import DownloadSection from "../components/Home/Landing Page Components/DownloadSection";
import { useLoader } from "../components/common/Loader/LoaderProvider";
import { useDispatch } from "react-redux";
import { getCMSData } from "../apis/user";

const Privacy = () => {
  const [privacyValue, setPrivacyValue] = useState("");
  const loaderContext = useLoader();
  const { showLoader, hideLoader } = loaderContext;
  const dispatch = useDispatch();

  const fetchCMSData = async () => {
    showLoader();
    dispatch(getCMSData("privacy"))
      .then((res) => {
        // console.log("res=>>>>", res);
        if (res.status) {
          setPrivacyValue(res?.data?.data?.content);
          hideLoader();
        } else {
          hideLoader();
        }
      })
      .finally(() => {
        hideLoader();
      });
  };

  useEffect(() => {
    document.title = "TXTBET"; // Quick solution
    fetchCMSData();

    hideLoader();
  }, []);
  return (
    <div className="!overflow-x-hidden !h-screen">
      <Header />
      <div
        className="!w-full !px-4 !pt-8 !font-bold"
        id="privacy-policy-content"
      >
        <div className="flex flex-row justify-center text-4xl font-bold">
          Privacy Policies
        </div>
        {privacyValue ? (
          <div
            className="pt-10 px-10 bg-white shadow-md rounded-md text-gray-700"
            style={{ lineHeight: "1.6" }} // Optional: Improves readability
            dangerouslySetInnerHTML={{ __html: privacyValue }}
          />
        ) : (
          "Privacy & Policies Coming Soon!"
        )}
      </div>
      <DownloadSection />
    </div>
  );
};

export default Privacy;
